/* eslint-disable */
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 0;
  background-color: white;
  min-height: 100vh;
`;

export const Heading = styled.div`
  background: #f3f4f8;
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 20px;
    color: #1a1a32;
    font-weight: 600;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px 16px;

    h3 {
      font-size: 18px;
    }
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  background-color: #f3f4f8;
  padding: 16px 24px;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    padding: 12px 16px;
    gap: 8px;
  }
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 48px;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  color: ${({ selected }) => (selected ? '#4A4BA9' : '#666')};
  cursor: pointer;
  border: 2px solid ${({ selected }) => (selected ? '#4A4BA9' : '#e0e0e0')};
  border-radius: 8px;
  transition:
    border 0.3s ease,
    color 0.3s ease;

  &:hover {
    border-color: #4a4ba9;
  }

  @media only screen and (max-width: 768px) {
    width: 48%;
    height: 44px;
    font-size: 14px;
  }

  @media only screen and (max-width: 480px) {
    width: 100%;
    height: 48px;
  }
`;

export const TabTitle = styled.div`
  font-size: 15px;
  text-transform: capitalize;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-top: 24px;
  width: 100%;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    gap: 16px;
    margin-top: 16px;
  }
`;

export const ModuleLine = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 16px;
  margin-bottom: 4px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const FormInputWrapper = styled.div`
  flex: 0 0 calc(50% - 8px);
  font: Biotif, Regular;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: auto;
  }

  @media only screen and (max-width: 480px) {
    margin-bottom: 4px;
  }

  p {
    margin: 0;
  }

  label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 6px;
    display: block;
  }

  input,
  select,
  textarea {
    border-radius: 7px;
    opacity: 1;
    height: 40px;
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #ddd;
    padding: 8px 12px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #4a4ba9;
    }
  }

  input:disabled {
    background: #f3f4f8;
    cursor: not-allowed;
  }

  select {
    width: 100%;
    appearance: none;
    // background: white
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E")
      no-repeat right 12px center;
  }
`;

export const RegularButton = styled.button`
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background-color: #4a4ba9;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 16px;

  &:hover {
    background-color: #3a3b9a;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 2rem;
  color: #007bff;
`;
